var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"story-list-wrapper"},[_c('ul',{staticClass:"story-list"},_vm._l((_vm.stories),function(story,index){return _c('listItem',{key:index,attrs:{"story":story}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }